export function getHeaders(selectDialog = false) {
  const headers = [
  
    {
      text: 'deposit_invoice.invoice_number',
      className: 'fixed-cell left',
      // left: 55,
    },
    {
      text: 'deposit_invoice.invoice_date',
    },
   
  
    
    {
      text: 'address_book.code',
    },
    {
      text: 'waybill_entry.sender_company',
    },
    {
      text: 'address_book.sender',
    },
    {
      text: 'address_book.phonenumber',
    },
    {
      text: 'waybill_entry.receiver_company',
    },
    {
      text: 'address_book.receiver',
    },
    {
      text: 'address_book.phonenumber',
    },
    {
      text: 'waybill_entry.destination',
    },
    {
      text: 'Currency',
    },

    {
      text: 'waybill_entry.total',
    },

    {
      text: 'waybill_entry.sale_person',
    },
    {
      text: 'actions',
      className: 'fixed-cell',
      width: 400,
    },
  ];

  if (selectDialog) {
    headers.push({
      text: 'actions',
      className: 'fixed-cell',
      width: 80,
    });
  }

  return headers;
}
